import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["role", "tabindex", "onKeydown"]
const _hoisted_2 = { class: "flex items-start gap-3 px-4 py-4 sm:gap-4 sm:px-6 sm:py-6" }
const _hoisted_3 = { class: "min-w-0 flex-1" }
const _hoisted_4 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_5 = { class: "text-sm font-medium uppercase tracking-[0.7px] text-[#242B59]" }
const _hoisted_6 = {
  key: 0,
  class: "text-[10px] font-medium uppercase tracking-[0.55px] text-[#159A87]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["relative box-border w-full overflow-hidden rounded-2xl border bg-white shadow-[0_1px_3px_rgba(0,0,0,0.1),0_1px_2px_-1px_rgba(0,0,0,0.1)]", 
            $setup.isClickable
                ? 'cursor-pointer border-[#48DDC3] bg-[#F7FFFD] transition-all hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(72,221,195,0.2)] focus:outline-none focus:ring-2 focus:ring-[#48DDC3]'
                : 'border-[#E5E7EB]'
        ]),
    role: $setup.isClickable ? 'button' : undefined,
    tabindex: $setup.isClickable ? 0 : undefined,
    onClick: $setup.activate,
    onKeydown: [
      _withKeys(_withModifiers($setup.activate, ["prevent"]), ["enter"]),
      _withKeys(_withModifiers($setup.activate, ["prevent"]), ["space"])
    ]
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "absolute bottom-0 left-0 top-0 w-1.5 bg-[#48DDC3]" }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-[14px] shadow-[0_0_0_1px_#E5E5E5,0_1px_3px_rgba(0,0,0,0.1),0_1px_2px_-1px_rgba(0,0,0,0.1)]", $setup.isClickable ? 'bg-[#E6FFFA]' : 'bg-[#F5F6F8]'])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent($setup.actionIcon), {
          class: _normalizeClass(["h-5 w-5", $setup.isClickable ? 'text-[#242B59]' : 'text-[#48DDC3]']),
          "aria-hidden": "true"
        }, null, 8 /* PROPS */, ["class"]))
      ], 2 /* CLASS */),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('aura.cards.action.title')), 1 /* TEXT */),
          _createElementVNode("span", {
            class: "rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.7px]",
            style: _normalizeStyle({ backgroundColor: $setup.priority.color, color: $setup.priority.text })
          }, _toDisplayString($setup.priority.label), 5 /* TEXT, STYLE */),
          ($setup.isClickable)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('aura.cards.action.clickToAnalyze')), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createVNode($setup["AuraRichText"], {
          class: "mt-2 max-w-3xl text-sm font-normal leading-[23px] text-[#626468]",
          text: $props.action.description
        }, null, 8 /* PROPS */, ["text"])
      ])
    ])
  ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}